import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { PageI } from '@interfaces/page.interface';
import { UserI } from '@interfaces/user.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UsersHttpService {
  private slug_url = 'users';
  constructor(private readonly http: HttpClient) {}

  public getUsers(
    params = {
      page: 1,
      limit: 999,
    }
  ): Observable<PageI<UserI>> {
    return this.http.get<PageI<UserI>>(`${environment.OMNISMART_API_USERS}${this.slug_url}`, {
      params,
    });
  }

  public getUser(id: string): Observable<UserI> {
    return this.http.get<UserI>(`${environment.OMNISMART_API_USERS}${this.slug_url}/${id}`);
  }

  public createUser(user: UserI): Observable<UserI> {
    return this.http.post<UserI>(`${environment.OMNISMART_API_USERS}${this.slug_url}`, user);
  }

  public updateUser(id: string, user: UserI): Observable<UserI> {
    return this.http.put<UserI>(`${environment.OMNISMART_API_USERS}${this.slug_url}/${id}`, user);
  }

  public deleteUser(id: string): Observable<UserI> {
    return this.http.delete<UserI>(`${environment.OMNISMART_API_USERS}${this.slug_url}/${id}`);
  }

  public countUsers(): Observable<number> {
    return this.http.get<number>(`${environment.OMNISMART_API_USERS}${this.slug_url}/count`);
  }
}
